{
  "Earlier": "ANTERIOR",
  "noAnnouncements": "Recibirá información sobre las actividades de mantenimiento programadas y los problemas del producto que se están solucionando.",
  "noAnnouncementsTitle": "Sus anuncios aparecerán aquí"
}
